/**
 * «Тревоги за сутки» на экране «Задания» (§2.5, дополнение) — то же, что
 * уходит в Telegram ops-чат (`STAFF_ALERT_TG_CHAT_IDS`), но в приложении.
 * Жалоба водителя: «алерты, которые в Telegram уходят, чтобы и в приложении
 * были».
 *
 * Партнёру секция не показывается — гейт по роли живёт в вызывающей
 * странице (`pages/tasks.tsx`), тем же приёмом, что у соседней «Свободные».
 *
 * Ручки ещё нет в проде (см. `api/alerts.ts`) — `useScoutAlerts` отдаёт
 * `null` на 404/403, и секция тогда просто не рисуется, без сообщения об
 * ошибке.
 */
import { Link } from 'react-router-dom'
import {
  alertKindLabel,
  alertKindTone,
  resolveAlertVehicleId,
  useScoutAlerts,
  type ScoutAlert,
} from '@/api/alerts'
import { useScoutVehicles, type ScoutVehicle } from '@/api/vehicles'
import { timeAgo } from '@/lib/geo'
import { Chip } from '@/components/ui'

export function AlertsSection() {
  const alerts = useScoutAlerts()
  const vehicles = useScoutVehicles()

  const list = alerts.data
  if (!list || list.length === 0) return null

  const fleet = vehicles.data?.vehicles ?? []

  return (
    <section className="mb-6">
      <h2 className="mb-2 text-sm font-medium uppercase tracking-wide opacity-50">
        Тревоги за сутки
      </h2>
      <ul className="flex flex-col gap-2">
        {list.map((a) => (
          <AlertRow key={a.id} alert={a} vehicles={fleet} />
        ))}
      </ul>
    </section>
  )
}

function AlertRow({
  alert,
  vehicles,
}: {
  alert: ScoutAlert
  vehicles: readonly ScoutVehicle[]
}) {
  const vehicleId = resolveAlertVehicleId(alert, vehicles)
  const ago = timeAgo(alert.createdAt)

  const content = (
    <>
      <div className="flex items-center gap-2">
        <span className="font-mono text-lg font-bold">
          {alert.vehicleNumber || 'Байк неизвестен'}
        </span>
        <Chip tone={alertKindTone(alert.kind)}>{alertKindLabel(alert.kind)}</Chip>
      </div>
      {alert.title ? <p className="mt-1 text-sm opacity-80">{alert.title}</p> : null}
      {ago ? <p className="mt-0.5 text-xs opacity-50">{ago}</p> : null}
    </>
  )

  return (
    <li className="rounded-xl border border-white/10 bg-white/5 p-3">
      {vehicleId ? (
        <Link to={`/bike/${vehicleId}`} className="block">
          {content}
        </Link>
      ) : (
        content
      )}
    </li>
  )
}
